import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets() {
        return ['file', 'add', 'remove'];
    }

    connect() {
        const input = this.targets.find('file');
        const add = this.targets.find('add');
        const remove = this.targets.find('remove');
        const fileName = add.querySelectorAll('span.file-name');
        const fileNameDefault = add.getAttribute('data-file-name-default') ?? fileName[0].innerHTML;

        add.addEventListener('click', (e) => {
            e.preventDefault();
            input.click();
        });

        remove.addEventListener('click', (e) => {
            e.preventDefault();
            input.value = "";
            setFileName(fileNameDefault);
            remove.classList.add('hidden');
        });

        this.element.addEventListener('drop', (e) => {
            e.preventDefault();
            remove.classList.remove('hidden');

            if (e.dataTransfer.items) {
                [...e.dataTransfer.items].forEach((item) => {
                    if (item.kind === 'file') {
                        const file = item.getAsFile();
                        if (file.size === 0) {
                            input.value = "";
                            setFileName(fileNameDefault);
                        } else {
                            const dataTransfer = new DataTransfer();
                            dataTransfer.items.add(file);
                            input.files = dataTransfer.files;
                            setFileName(file.name);
                        }
                    }
                });
            } else if (e.dataTransfer.files) {
                [...e.dataTransfer.files].forEach((file) => {
                    if (file.size === 0) {
                        input.value = "";
                        setFileName(fileNameDefault);
                    } else {
                        input.files = e.dataTransfer.files;
                        setFileName(file.name);
                    }
                });
            } else {
                remove.classList.add('hidden');
            }
            this.element.classList.remove('active-drag-area');
        });

        // Prevent the browser's default drag behavior.
        this.element.addEventListener('dragover', (e) => {
            this.element.classList.add('active-drag-area');
            e.preventDefault();
        });

        this.element.addEventListener('dragenter', () => {
            this.element.classList.add('active-drag-area');
        });

        this.element.addEventListener('dragleave', () => {
            this.element.classList.remove('active-drag-area');
        });

        input.addEventListener('change', () => {
            const fileNames = [];
            for (const file of input.files) {
                if (file.size > 0) {
                    fileNames.push(file.name);
                }
            }

            if (fileNames.length > 0) {
                setFileName(fileNames.join(', '));
                remove.classList.remove('hidden');
            } else {
                input.value = '';
                setFileName(fileNameDefault);
                remove.classList.add('hidden');
            }
        });

        const setFileName = (name) => {
            add.querySelectorAll('span.file-name').forEach((fileName) => {
                fileName.innerHTML = name;
            })
        }
    }
}
